import { render, staticRenderFns } from "./Daci.vue?vue&type=template&id=701d48b5&scoped=true&"
import script from "./Daci.vue?vue&type=script&lang=js&"
export * from "./Daci.vue?vue&type=script&lang=js&"
import style0 from "./Daci.vue?vue&type=style&index=0&id=701d48b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701d48b5",
  null
  
)

export default component.exports